import {groupBy, mergeArrsByKey} from '@/helpers';

import {http, httpWithLoader} from '@/http-common';

const state = () => ({
    activeStep: 1, // Активный шаг
    groupItemsBy: { // Группировка в шапке
        name: 'area_id',
        label: 'По ОПД'
    },
    areas: [], // ОПД
    groupKinds: [], // Сгруппированные ВПД
    kinds: [], // ВПД по выбранным ОПД
    lifecycles: [], // Жизненные циклы
    okveds: [], // ОКВЭД
    okzs: [], // ОКЗ
    standards: [], // стандарты
    selectedAreas: [], // Выбранные юзером ОПД
    standard: null, // Стандарт по выбранному ВПД
    workActions: [], // Трудовые действия
    workFunctionItems: [], // Трудовые знания/действия/умения
    commonWorkFunctions: [], // Общие трудовые функции
    workFunctions: [], // Трудовые функции
    workFunctionsByQualification: [], // Трудовые функции квалификации
    workFunctionsByStandard: [], // Трудовые функции по выбранному стандарту
    workKnowledge: [], // Знания
    workSkills: [], // Умения
    trainings: [], // Взаимосвязи

    //programs: [], // Образовательные программы
    programsByQualification: [], // Образовательные программы квалификации
    programsByQualificationFromNSI: [],
    externalPrograms: [],
    groupQualifications: [], // Сгруппированные квалификации
    qualification: [], // Квалификация по выбранной ПК
    qualifications: [], // Квалификации, добавленные в рамку
    qualificationsByKind: [], // Список квалификаций, относящихся к ВПД
    orkInfo: {}, // Информация по рамке

    openedTraining: null,
    programsFromOpenedTraining: [],

    competences: [], // Список компетенций
    hardSkills: [], // Хард скиллы
    hardSkillsByQualification: [], // Хард скиллы квалификации
    softSkills: [], // Софт скиллы
    softSkillsByQualification: [], // Софт скиллы квалификации

    interrelationsByQualification: [], // Взаимосвязи квалификации

    intersectionsPaths: []
});

const getters = {
    GET_AREA_BY_ID: (state) => (id) => { // Получение ОПД по id
        return state.areas.find((item) => item.id === id);
    },
    GET_KIND_BY_ID: (state) => (id) => { // Получение ВПД по id
        return state.kinds.find((item) => item.id === id);
    },
    GET_STANDARD_BY_ID: (state) => (id) => { // Получение стандарта по id
        return state.standards.find((item) => item.id === id);
    },
    GET_LIFECYCLE_BY_ID: (state) => (id) => { // Получение жизненного цикла по id
        return state.lifecycles.find((item) => item.id === id);
    },
    GET_OKVEDS_BY_ID: (state) => (id) => { // Получение ОКВЭД по id
        return state.okveds.find((item) => item.id === id);
    },
    GET_OKZS_BY_ID: (state) => (id) => { // Получение ОКЗ по id
        return state.okzs.find((item) => item.id === id);
    },
    GET_WORK_FUNCTION_BY_ID: (state) => (id) => { // Получение ОПД по id
        return state.workFunctions.find((item) => item.id === id);
    },
    IS_AREAS_EMPTY: (state) => {
        return state.areas.length === 0;
    },
    IS_KINDS_EMPTY: (state) => {
        return state.kinds.length === 0;
    },
    IS_STANDARDS_EMPTY: (state) => {
        return state.standards.length === 0;
    },
};

const mutations = {
    // Добавить образовательую программу
    // ADD_PROGRAM(state, program) {
    //     state.programs.push(program);
    // },
    // Добавить трудовую функцию
    ADD_WORK_FUNCTION(state, workFunction) {
        state.workFunctions.push(workFunction);
    },
    // Добавить общую трудовую функцию к стандарту
    ADD_COMMON_WORK_FUNCTION_BY_STANDARD(state, workFunction) {
        state.workFunctionsByStandard.push(workFunction);
    },
    // Добавить трудовую функцию к стандарту
    ADD_WORK_FUNCTION_BY_STANDARD(state, workFunction) {
        state.workFunctionsByStandard.workFunctions.push(workFunction);
    },
    ADD_NEW_FIELDS_FOR_QUALIFICATIONS(state, qualificatios) {
        state.qualifications = state.qualifications.map(el => Object.assign(el, qualificatios.find(qualification => qualification.id === el.id)))
    },
    DELETE_AND_SET_WORK_FUNCTIONS_BY_STANDARD (state, newWorkFunctionsByStandard) {
        const tempData = [].concat(state.workFunctionsByStandard)
        const index = tempData.findIndex(el => el.id === newWorkFunctionsByStandard.id)
        tempData[index].work_functions = newWorkFunctionsByStandard.work_functions
        state.workFunctionsByStandard = tempData;
    },
    CHANGE_WORK_FUNCTIONS_BY_STANDARD(state, workFunctionsByStandard) {
        state.workFunctionsByStandard = state.workFunctionsByStandard.map(commonItem => commonItem.work_functions.find(item => item.id === workFunctionsByStandard.id) ? Object.assign(commonItem, { work_functions: commonItem.work_functions.map(item => item.id === workFunctionsByStandard.id ? workFunctionsByStandard : item) }) : commonItem);
    },
    CHANGE_WORK_FUNCTIONS_BY_QUALIFICATION(state, workFunctionsByQualification) {
        state.workFunctionsByQualification = state.workFunctionsByQualification.map(commonItem => commonItem.work_functions.find(item => item.id === workFunctionsByQualification.id) ? Object.assign(commonItem, { work_functions: commonItem.work_functions.map(item => item.id === workFunctionsByQualification.id ? workFunctionsByQualification : item) }) : commonItem);
    },
    // Сгруппировать ВПД по ключу
    GROUP_KINDS(state, field) {
        var groupData = state[field === 'lifecycle_id' ? 'lifecycles' : 'selectedAreas'].map((item) => {
            const obj = {
                groupId: item.id,
                name: item.name,
                items: state?.kinds.filter((data) => data[field] === item.id) || []
            };

            if (field === 'area_id') {
                obj.code = item.code;
            }


            return obj;
        });

        let empt = state.qualifications.filter(q => q.standard_id === null);

        if (empt.length > 0) {
            groupData.push({groupId: 0, code: 0, name: 'Квалификации, не привязанные к профстандарту', items: [{name: '–', id: 0, lifecycle_id: null}],
            });
        }

        if (empt.length === 0) {
            groupData = groupData.filter(group => group.code !== 0);
        }

        state.groupKinds = groupData;
    },
    // Сгруппировать квалификации по ключу
    GROUP_QUALIFICATIONS(state, field) {
        const childrenIds = [...new Set(state.kinds.map((item) => item['id']))];
        const childData = [];

        for (const id of childrenIds) {
            childData.push({
                kindId: id,
                items: state?.qualifications.filter((item) => item['kind_id'] === id) || [],
                name: state?.kinds.find((item) => item.id === id)?.name
            });
        }

        const groupData = state[field === 'lifecycle_id' ? 'lifecycles' : 'selectedAreas'].map((item) => {
            const ids = state.kinds.filter((kind) => kind[field] === item.id).map((item) => item.id);

            const obj = {
                groupId: item.id,
                name: item.name,
                items: childData.filter((data) => {
                    if (ids.includes(data.kindId)) {
                        return data;
                    }
                }) || []
            };

            if (field === 'area_id') {
                obj.code = item.code;
            }

            return obj;
        });

        let empt = state.qualifications.filter(q => q.standard_id === null);

        if (empt.length > 0) {
            groupData.push({groupId: 0,  code: '–', name: 'Квалификации, не привязанные к профстандарту', items: [{
                    groupId: 0,
                    name: 'Квалификации, не привязанные к профстандарту',
                    code: '–',
                    items: empt,
                }]
            });
        }



        state.groupQualifications = groupData;
    },

    RESET_QUALIFICATIONS(state, field) {
        state.groupQualifications = [];
    },
    PREV_STEP(state) {
        if (state.activeStep > 1) {
            state.activeStep -= 1;
        }
    },
    NEXT_STEP(state) {
        if (state.activeStep < 6) {
            state.activeStep += 1;
        }
    },
    CUR_STEP(state, curStep) {
        state.activeStep = curStep;
    },
    SET_AREAS(state, areas) {
        state.areas = areas;
    },
    SET_COMPETENCES(state, competences) {
        const groupCompetences = groupBy('name', competences);

        state.competences = groupCompetences;
    },
    SET_EDUCATION_PROGRAMS(state, programs) {
        state.programs = programs;
    },
    SET_HARD_SKILLS(state, hardSkills) {
        state.hardSkills = hardSkills;
    },
    SET_HARD_SKILLS_BY_QUALIFICATION(state, hardSkillsByQualification) {
        state.hardSkillsByQualification = hardSkillsByQualification;
    },
    SET_INTERRELATIONS_BY_QUALIFICATION(state, interrelationsByQualification) {
        state.interrelationsByQualification = interrelationsByQualification;
    },
    SET_KINDS(state, kinds) {
        state.kinds = kinds;
    },
    SET_STANDARDS(state, standards) {
        state.standards = standards;
    },
    SET_KIND(state, kind) {
        state.kinds = state.kinds.map(el => el.id === kind.id ? el = kind : el);
    },
    SET_ITEMS_GROUP(state, groupItemsBy) {
        state.groupItemsBy = groupItemsBy;
    },
    SET_LIFECYCLES(state, lifecycles) {
        state.lifecycles = lifecycles;
    },
    SET_OKVEDS(state, okveds) {
        state.okveds = okveds;
    },
    SET_OKZS(state, okzs) {
        state.okzs = okzs;
    },
    SET_PROGRAMS(state, programs) {
        state.programs = programs;
    },
    SET_PROGRAMS_BY_QUALIFICATION(state, programsByQualification) {
        state.programsByQualification = programsByQualification;
    },
    SET_QUALIFICATION(state, qualification) {
        state.qualification = qualification;
    },
    SET_QUALIFICATIONS(state, qualifications) {
        state.qualifications = qualifications;
    },
    SET_QUALIFICATIONS_BY_KIND(state, qualificationsByKind) {
        state.qualificationsByKind = qualificationsByKind;
    },
    SET_ORK_INFO(state, orkInfo) {
        state.orkInfo = orkInfo
    },
    SET_SELECTED_AREAS(state, selectedAreas) {
        state.selectedAreas = selectedAreas;
    },
    SET_SOFT_SKILLS(state, softSkills) {
        state.softSkills = softSkills;
    },
    SET_SOFT_SKILLS_BY_QUALIFICATION(state, softSkillsByQualification) {
        state.softSkillsByQualification = softSkillsByQualification;
    },
    SET_STANDARD(state, standard) {
        state.standard = standard;
    },
    SET_WORK_ACTIONS(state, workActions) {
        state.workActions = workActions;
    },
    SET_WORK_FUNCTIONS(state, workFunctions) {
        state.workFunctions = workFunctions;
    },
    SET_WORK_KNOWLEDGE(state, workKnowledge) {
        state.workKnowledge = workKnowledge;
    },
    SET_WORK_SKILLS(state, workSkills) {
        state.workSkills = workSkills;
    },
    SET_WORK_FUNCTIONS_BY_QUALIFICATION(state, workFunctionsByQualification) {
        state.workFunctionsByQualification = workFunctionsByQualification;
        state.workFunctions = state.workFunctionsByQualification.reduce((carry, item) => {
            return [...carry, ...item['work_functions']];
        }, []);
    },
    SET_WORK_FUNCTIONS_BY_STANDARD(state, workFunctionsByStandard) {
        state.workFunctionsByStandard = workFunctionsByStandard;
    },
    SET_WORK_FUNCTION_ITEMS(state, workFunctionItems) {
        state.workFunctionItems = workFunctionItems;
    },
    SET_TRAININGS(state, trainings) {
        state.trainings = trainings;
    },
    SET_COMMON_WORK_FUNCTIONS(state, commonWorkFunctions) {
        state.commonWorkFunctions = commonWorkFunctions
    },
    SET_INTERRELATIONS_PATHS(state, intersectionsPaths) {
        state.intersectionsPaths = intersectionsPaths
    },
    SET_PROGRAMS_BY_QUALIFICATION_FROM_NSI(state, programs) {
        state.programsByQualificationFromNSI = programs;
    },
    SET_EXTERNAL_PROGRAMS(state, programs) {
        state.externalPrograms = programs;
    },
    SET_PROGRAMS_FOR_TRAINING(state, programs) {
        state.programsFromOpenedTraining = programs;
    },
};

const handleError = ((error, commit) => {
    commit('common/TOGGLE_ALERT', { open: true, status: 'error', text: `Что то пошло не так, пожалуйста перезагрузите страницу и попробуйте ещё раз` }, { root: true })
    console.log(`url: ${ error.config ? error.config.url : '-' }\nmethod: ${ error.config ? error.config.method : '-' }\npayload: ${ error.config ? error.config.data : '-' }`);

    if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        const tempMessage = error.response.data.trace.map(el => el.file).join('\n')
        console.log(`message: ${error.response.data.message}\nfiles:\n${tempMessage}`);
    } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the
        // browser and an instance of
        // httpWithLoader.ClientRequest in node.js
        console.log(error.request);
    } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Ошибка', error.message);
    }
});

const actions = {
    /*--------- ОПД ---------*/
    // Получить ОПД
    async LOAD_AREAS({ commit, rootState }) {
        await httpWithLoader.get(`/${rootState.ork.curOrkId}/areas`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_AREAS', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },
    async LOAD_AREAS_NO_ORK({ commit, rootState }) {
        await httpWithLoader.get(`/areas`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_AREAS', response.data)
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Получить ОПД не включая глобальный прелоадер
    async SILENT_LOAD_AREAS({ commit, rootState }) {
        await http.get(`/${rootState.ork.curOrkId}/areas`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_AREAS', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    /*--------- ВПД ---------*/
    // Обновить ВПД
    async UPDATE_KIND({ commit, rootState }, params) {
        return await httpWithLoader.put(`/${rootState.ork.curOrkId}/kinds/${params.kind_id}`, params, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_KIND', response.data);

            return response.data;
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    async LOAD_PROGRAMS_BY_QUALIFICATION_FROM_NSI({commit, rootState, state}, qualificationId) {
        await httpWithLoader.get(`/qualifications/${qualificationId}/education-programs`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            },
        })
            .then((response) => {
                console.log(response.data);
                commit('SET_PROGRAMS_BY_QUALIFICATION_FROM_NSI', response.data);
            })
    },

    //  Удалить ВПД
    async DELETE_KINDS({ commit, rootState, state }, ids) {
        await httpWithLoader.delete(`/${rootState.ork.curOrkId}/ork/kinds`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            },
            data: ids
        })
        .then((response) => {
            commit('SET_KINDS', response.data);
            commit('GROUP_KINDS', state.groupItemsBy.name);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Получить ВПД из рамки
    async LOAD_KINDS({ commit, rootState, state }) {
        await httpWithLoader.get(`/${rootState.ork.curOrkId}/ork/kinds`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_KINDS', response.data);
            commit('GROUP_KINDS', state.groupItemsBy.name);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    async LOAD_KINDS_NO_ORK({ commit, rootState, state }) {
        await httpWithLoader.get(`/kinds`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_KINDS', response.data);
            commit('GROUP_KINDS', state.groupItemsBy.name);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    async LOAD_STANDARDS_NO_ORK({ commit, rootState, state }) {
        await httpWithLoader.get(`/standards-all`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_STANDARDS', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Получить ВПД по выбранным ОПД
    async LOAD_KINDS_BY_AREAS({ commit, rootState, state }, areasIds) {
        return await httpWithLoader.get(`/${rootState.ork.curOrkId}/kinds?area_id=${ areasIds }`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            return response.data;
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    async LOAD_KIND_BY_ID({commit, rootState}, params) {
        return await httpWithLoader.get(`/${params.orkId}/kinds/${params.kindId}`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
            .then((response) => {
                return response.data;
            })
            .catch((reject) => {
                handleError(reject, commit);
            })
    },

    // Получить ВПД по id ОПД
    async LOAD_KINDS_BY_AREA({ commit, rootState }, areaId) {
        return await httpWithLoader.get(`/${rootState.ork.curOrkId}/areas/${ areaId }/kinds`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            return response.data;
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    //  Сохранить выбранные ВПД
    async SAVE_KINDS({ commit, rootState, state }, params) {
        await httpWithLoader.put(`/${rootState.ork.curOrkId}/ork/kinds`, params, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_KINDS', response.data);
            commit('GROUP_KINDS', state.groupItemsBy.name);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },


    //  Сохранить выбранные ВПД на основе переданных ПК
    async SAVE_KINDS_FROM_QUALIFICATIONS({ commit, dispatch, rootState, state}, params) {
        await httpWithLoader.put(`/${rootState.ork.curOrkId}/ork/kinds-from-qualifications`, params, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
            .then((response) => {

                commit('SET_KINDS', response.data.kinds);
                commit('SET_QUALIFICATIONS', response.data.qualifications);
                const curKinds = Array.from(new Set(state.kinds.map(el => el.area_id)));
                const filteredAreas = state.areas.filter(el => curKinds.includes(el.id));
                commit('SET_SELECTED_AREAS', filteredAreas);

                commit('GROUP_KINDS', state.groupItemsBy.name);

            })
            .catch((reject) => {
                handleError(reject, commit)
            });
    },


    /*--------- КВАЛИФИКАЦИИ ---------*/
    //  Удалить квалификации
    async DELETE_QUALIFICATIONS({ commit, rootState }, ids) {
        await httpWithLoader.delete(`/${rootState.ork.curOrkId}/ork/qualifications`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            },
            data: ids
        })
        .then((response) => {
            commit('SET_QUALIFICATIONS', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Получить квалификацию
    async LOAD_QUALIFICATION({ commit, rootState }, data) {
        let id = Number.isInteger(data) ? data : data.id;
        let url = Number.isInteger(data) ? `/${rootState.ork.curOrkId}` :  `` ;
        await httpWithLoader.get(url + `/qualifications/${ id }`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_QUALIFICATION', response.data);
        });
    },

    async LOAD_QUALIFICATION_NO_ORK({ commit, rootState }, data) {
        let id = Number.isInteger(data) ? data : data.id;
        await httpWithLoader.get(`/qualification/${ id }`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_QUALIFICATION', response.data);
        });
    },

    // Получить квалификации, добавленных в рамку
    async LOAD_QUALIFICATIONS({ commit, rootState }) {
        await httpWithLoader.get(`/${rootState.ork.curOrkId}/ork/qualifications`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_QUALIFICATIONS', response.data);
        });
    },

    // Получить квалификации, добавленных в рамку не включая глобальный прелоадер
    async SILENT_LOAD_QUALIFICATIONS({ commit, rootState }, ids) {
        await http.get(`/${rootState.ork.curOrkId}/ork/qualifications`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_QUALIFICATIONS', response.data);
        });
    },

    // Получить квалификации, добавленных в рамку с взаимосвязями
    async LOAD_QUALIFICATIONS_WITH_RELATIONS({ commit, rootState }, relations) {
        await httpWithLoader.get(`/${rootState.ork.curOrkId}/ork/qualifications?relations=${ relations }`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('ADD_NEW_FIELDS_FOR_QUALIFICATIONS', response.data);
        });
    },

    // Получить квалификации, добавленных в рамку с взаимосвязями без вызова глобального предлоадера
    async SILENT_LOAD_QUALIFICATIONS_WITH_RELATIONS({ commit, rootState }, relations) {
        await http.get(`/${rootState.ork.curOrkId}/ork/qualifications?relations=${ relations }`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('ADD_NEW_FIELDS_FOR_QUALIFICATIONS', response.data);
        });
    },

    // Получить список квалификаций, относящихся к ВПД
    async LOAD_QUALIFICATIONS_BY_KIND({ commit, rootState }, id) {
        await httpWithLoader.get(`/${rootState.ork.curOrkId}/qualifications?kind_id=${ id }`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_QUALIFICATIONS_BY_KIND', response.data);
        });
    },

    //  Сохранить выбранные ВПД
    async SAVE_QUALIFICATIONS({ commit, rootState }, params) {
        await httpWithLoader.put(`/${rootState.ork.curOrkId}/ork/qualifications`, params, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_QUALIFICATIONS', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    async UPDATE_COMPETENCE({commit, rootState}, {id, ...params}) {
        console.log('upd competence');
        await httpWithLoader.put(`/${rootState.ork.curOrkId}/competence/${id}`, params, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`,
            }
        });
    },

    async DETACH_COMPETENCE({commit, rootState}, {qualificationId, competenceId}) {
        await httpWithLoader.delete(`/${rootState.ork.curOrkId}/qualifications/${qualificationId}/competence`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`,
            },
            data: {
                competence_id: competenceId,
            }
        }).then((response) => {
            commit('SET_QUALIFICATION', response.data);
        });
    },

    async ATTACH_COMPETENCE({commit, rootState}, {qualificationId, competenceId}) {
        await httpWithLoader.put(`/${rootState.ork.curOrkId}/qualifications/${qualificationId}/competence`, {competence_id: competenceId}, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`,
            }
        }).then((response) => {
            commit('SET_QUALIFICATION', response.data);
        });
    },

    async CREATE_COMPETENCE({commit, rootState}, {competence, qualificationId = 0}) {

        await httpWithLoader.post(`/${rootState.ork.curOrkId}/competence`, competence, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`,
            }
        }).then((response) => {
            this.dispatch('editor/ATTACH_COMPETENCE', {qualificationId: qualificationId, competenceId: response.data.id})
        })

    },

    async UPDATE_QUALIFICATION({ commit, rootState }, { id, ...params }) {
        await httpWithLoader.put(`/${rootState.ork.curOrkId}/qualifications/${ id }`, params, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_QUALIFICATION', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Получить информацию по ОРК
    async LOAD_ORK_INFO({ commit, rootState }) {
        await httpWithLoader.get(`/user/ork/${rootState.ork.curOrkId}`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_ORK_INFO', response.data);
        });
    },

    //  Сохранить информацию по ОРК
    async SAVE_ORK_INFO({ commit, rootState }, { id, params}) {
        await httpWithLoader.put(`/user/ork/${rootState.ork.curOrkId}`, params, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_ORK_INFO', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    /*--------- ЖИЗНЕННЫЕ ЦИКЛЫ ---------*/
    // Получить жизненные циклы
    async LOAD_LIFECYCLES({ commit, rootState }) {
        await httpWithLoader.get(`/${rootState.ork.curOrkId}/lifecycles`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_LIFECYCLES', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    /*--------- ОКВЭДЫ ---------*/
    // Получить ОКВЭДЫ
    async LOAD_OKVEDS({ commit, rootState }) {
        await httpWithLoader.get(`/${rootState.ork.curOrkId}/okveds`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_OKVEDS', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },
    // Получить ОКВЭДЫ не включая глобальный прелоадер
    async SILENT_LOAD_OKVEDS({ commit, rootState }) {
        await http.get(`/${rootState.ork.curOrkId}/okveds`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_OKVEDS', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    /*--------- ОКЗ ---------*/
    // Получить ОКЗ
    async LOAD_OKZS({ commit, rootState }) {
        await httpWithLoader.get(`/${rootState.ork.curOrkId}/okzs`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_OKZS', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },
    // Получить ОКЗ не включая глобальный прелоадер
    async SILENT_LOAD_OKZS({ commit, rootState }) {
        await http.get(`/${rootState.ork.curOrkId}/okzs`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_OKZS', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Создать ОКЗ
    async CREATE_OKZS({ commit, rootState }, params) {
        await httpWithLoader.put(`/${rootState.ork.curOrkId}/standards/${ params.standardId }/okzs`, params.ids, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_STANDARD', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Создать ОКЗ
    async DELETE_OKZS({ commit, rootState }, params) {
        await httpWithLoader.delete(`/${rootState.ork.curOrkId}/standards/${ params.standardId }/okzs`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            },
            data: params.ids
        })
        .then((response) => {
            commit('SET_STANDARD', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Создать ОКВЕД
    async CREATE_OKVED({ commit, rootState }, params) {
        await httpWithLoader.put(`/${rootState.ork.curOrkId}/standards/${ params.standardId }/okveds`, params.ids, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_STANDARD', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Создать ОКВЕД
    async DELETE_OKVED({ commit, rootState }, params) {
        await httpWithLoader.delete(`/${rootState.ork.curOrkId}/standards/${ params.standardId }/okveds`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            },
            data: params.ids
        })
        .then((response) => {
            commit('SET_STANDARD', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    /*--------- ПРОГРАММЫ ---------*/
    // Создать программу
    async CREATE_PROGRAM({ state, commit, rootState }, params) {
        return await httpWithLoader.post(`/${rootState.ork.curOrkId}/education-programs`, params, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_PROGRAMS_BY_QUALIFICATION', [...state.programsByQualification, response.data]);

            return response.data
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Удаление программы
    async DELETE_PROGRAM({ state, commit, rootState }, id) {
        await httpWithLoader.delete(`/${rootState.ork.curOrkId}/education-programs/${id}`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then()
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Получить программы квалификации
    async LOAD_PROGRAMS_BY_QUALIFICATION({ commit, rootState }, id) {
        await httpWithLoader.get(`/${rootState.ork.curOrkId}/qualifications/${ id }/education-programs`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_PROGRAMS_BY_QUALIFICATION', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    async LOAD_PROGRAMS_BY_QUALIFICATION_NO_ORK({ commit, rootState }, id) {
        await httpWithLoader.get(`/qualifications/${ id }/education-programs`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_PROGRAMS_BY_QUALIFICATION', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Получить программы квалификации не включая глобальный прелоадер
    async SILENT_LOAD_PROGRAMS_BY_QUALIFICATION({ commit, rootState }, data) {
        let id = Number.isInteger(data) ? data : data.id;
        let url = Number.isInteger(data) ? `/${rootState.ork.curOrkId}` :  `` ;
        await http.get(url + `/qualifications/${ id }/education-programs`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_PROGRAMS_BY_QUALIFICATION', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Обновить список образовательных программ
    async UPDATE_PROGRAMS({ commit, rootState }, params) {
        await httpWithLoader.put(`/${rootState.ork.curOrkId}/education-programs/${ params.id }`, {
            ...params
        }, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_PROGRAMS', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Обновить образовательную программу
    async UPDATE_PROGRAM({ state, commit, rootState }, params) {
        return await httpWithLoader.put(`/${rootState.ork.curOrkId}/education-programs/${ params.id }`, {
            ...params
        }, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            // Склеиваем обновленную программу в список программ
            // const mergedArr = mergeArrsByKey([response.data], state.programs, 'id');

            // commit('SET_PROGRAMS', mergedArr);

            return response.data;
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Обновить программы квалификации
    async UPDATE_PROGRAMS_BY_QUALIFICATION({ commit, rootState }, { id, ids }) {
        await httpWithLoader.put(`/${rootState.ork.curOrkId}/qualifications/${ id }/education-programs`, ids, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_PROGRAMS_BY_QUALIFICATION', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Обновить программы квалификации
    async UPDATE_PROGRAMS_BY_INTERRELATIONS({ commit, rootState }, { id, ids }) {
        await httpWithLoader.put(`/${rootState.ork.curOrkId}/qualifications/${ id }/education-programs`, ids, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            return response.data;
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    /*--------- СТАНДАРТЫ ---------*/
    // Создать стандарт
    async CREATE_STANDARD({ commit, rootState }, params) {
        const { onlyCreate } = params; // Поле нужно для того чтобы не обновлять стандарт в стейте, если это не нужно

        return await httpWithLoader.post(`/${rootState.ork.curOrkId}/standards`, params, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            if (!onlyCreate) {
                commit('SET_STANDARD', response.data);
            }

            return response.data;
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Получить стандарт
    async LOAD_STANDARD({ commit, rootState }, id) {
        await httpWithLoader.get(`/${rootState.ork.curOrkId}/standards/${ id }`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_STANDARD', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Получить стандарт не включая глобальный прелоадер
    async SILENT_LOAD_STANDARD({ commit, rootState }, data) {
        let id = Number.isInteger(data) ? data : data.id;
        let url = Number.isInteger(data) ? `/${rootState.ork.curOrkId}` :  `` ;
        await http.get(url + `/standards/${ id }`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_STANDARD', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    async RESET_STANDARD({commit, rootState}) {
        commit('SET_STANDARD', null);
    },

    // Обновить стандарт
    async UPDATE_STANDARD({ commit, rootState }, params) {
        await httpWithLoader.put(`/${rootState.ork.curOrkId}/standards/${ params.id }`, {
            ...params
        }, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_STANDARD', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    /*--------- СОФТ СКИЛЛЫ ---------*/
    // Создать софт скилл
    async CREATE_SOFT_SKILL({ state, commit, rootState }, params) {
        return await httpWithLoader.post(`/${rootState.ork.curOrkId}/soft-skills`, params, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_SOFT_SKILLS', [...state.softSkills, response.data]);

            return response.data;
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Удалить хард скилл
    async DELETE_SOFT_SKILLS({ commit, rootState }, id) {
        await httpWithLoader.delete(`/${rootState.ork.curOrkId}/soft-skills/${id}`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then()
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Получить список софт скиллов
    async LOAD_SOFT_SKILLS({ commit, rootState }) {
        await httpWithLoader.get(`/${rootState.ork.curOrkId}/soft-skills`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_SOFT_SKILLS', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Получить софт скиллы квалификации
    async LOAD_SOFT_SKILLS_BY_QUALIFICATION({ commit, rootState }, id) {
        await httpWithLoader.get(`/${rootState.ork.curOrkId}/qualifications/${ id }/soft-skills`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_SOFT_SKILLS_BY_QUALIFICATION', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Получить софт скиллы квалификации не включая глобальный прелоадер
    async SILENT_LOAD_SOFT_SKILLS_BY_QUALIFICATION({ commit, rootState }, data) {
        let id = Number.isInteger(data) ? data : data.id;
        let url = Number.isInteger(data) ? `/${rootState.ork.curOrkId}` : ``;
        await http.get(url + `/qualifications/${ id }/soft-skills`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_SOFT_SKILLS_BY_QUALIFICATION', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Обновить софт скиллы квалификации
    async UPDATE_SOFT_SKILLS_BY_QUALIFICATION({ commit, rootState }, { id, ids }) {
        await httpWithLoader.put(`/${rootState.ork.curOrkId}/qualifications/${ id }/soft-skills`, ids, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_SOFT_SKILLS_BY_QUALIFICATION', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Удалить софт скиллы квалификации
    async DELETE_SOFT_SKILLS_BY_QUALIFICATION({ state, commit, rootState }, { id, ids }) {
        await httpWithLoader.delete(`/${rootState.ork.curOrkId}/qualifications/${ id }/soft-skills`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            },
            data: ids
        })
        .then((response) => {
            commit('SET_SOFT_SKILLS_BY_QUALIFICATION', state.softSkillsByQualification.filter(el => el.id !== ids[0]));
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Обновить софт скилл квалификации
    async UPDATE_SOFT_SKILL_BY_QUALIFICATION({ state, commit, rootState }, { id, ...params }) {
        return await httpWithLoader.put(`/${rootState.ork.curOrkId}/soft-skills/${ id }`, params, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            // Склеиваем обновленную программу в список программ
            const mergedArr = mergeArrsByKey([response.data], state.softSkillsByQualification, 'id');

            commit('SET_SOFT_SKILLS_BY_QUALIFICATION', mergedArr);

            return response.data;
        })
        .catch((reject) => {
            console.log(reject);
            handleError(reject, commit)
        });
    },

    /*--------- ХАРД СКИЛЛЫ ---------*/
    // Создать хард скилл
    async CREATE_HARD_SKILL({ state, commit, rootState }, params) {
        return await httpWithLoader.post(`/${rootState.ork.curOrkId}/hard-skills`, params, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_HARD_SKILLS', [...state.hardSkills, response.data]);

            return response.data;
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Удалить хард скилл
    async DELETE_HARD_SKILLS({ commit, rootState }, id) {
        await httpWithLoader.delete(`/${rootState.ork.curOrkId}/hard-skills/${id}`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then()
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Получить список хард скиллов
    async LOAD_HARD_SKILLS({ commit, rootState }) {
        await httpWithLoader.get(`/${rootState.ork.curOrkId}/hard-skills`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_HARD_SKILLS', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Получить хард скиллы квалификаии
    async LOAD_HARD_SKILLS_BY_QUALIFICATION({ commit, rootState }, id) {
        await httpWithLoader.get(`/${rootState.ork.curOrkId}/qualifications/${ id }/hard-skills`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_HARD_SKILLS_BY_QUALIFICATION', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Получить хард скиллы квалификаии не включая глобальный прелоадер
    async SILENT_LOAD_HARD_SKILLS_BY_QUALIFICATION({ commit, rootState }, data) {
        let id = Number.isInteger(data) ? data : data.id;
        let url = Number.isInteger(data) ? `/${rootState.ork.curOrkId}` : ``;
        await http.get(url + `/qualifications/${ id }/hard-skills`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_HARD_SKILLS_BY_QUALIFICATION', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Обновить хард скиллы квалификаии
    async UPDATE_HARD_SKILLS_BY_QUALIFICATION({ commit, rootState }, { id, ids }) {
        await httpWithLoader.put(`/${rootState.ork.curOrkId}/qualifications/${ id }/hard-skills`, ids, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_HARD_SKILLS_BY_QUALIFICATION', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Удалить хард скиллы квалификации
    async DELETE_HARD_SKILLS_BY_QUALIFICATION({ state, commit, rootState }, { id, ids }) {
        await httpWithLoader.delete(`/${rootState.ork.curOrkId}/qualifications/${ id }/hard-skills`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            },
            data: ids
        })
        .then((response) => {
            commit('SET_HARD_SKILLS_BY_QUALIFICATION', state.hardSkillsByQualification.filter(el => el.id !== ids[0]));
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Обновить софт скилл квалификации
    async UPDATE_HARD_SKILL_BY_QUALIFICATION({ state, commit, rootState }, { id, ...params }) {
        return await httpWithLoader.put(`/${rootState.ork.curOrkId}/hard-skills/${ id }`, params, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            // Склеиваем обновленную программу в список программ
            const mergedArr = mergeArrsByKey([response.data], state.hardSkillsByQualification, 'id');

            commit('SET_HARD_SKILLS_BY_QUALIFICATION', mergedArr);

            return response.data;
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    /*--------- ТРУДОВЫЕ ФУНКЦИИ ---------*/
    // Получить трудовые действия - пагинация
    // async LOAD_WORK_ACTIONS({ commit }, { page = 1, pageSize = 30 }) {
    //     await httpWithLoader.get(`/${rootState.ork.curOrkId}/workactions?page=${ page }&per_page=${ pageSize }`).then((response) => {
    //         commit('SET_WORK_ACTIONS', response.data);
    //     }).catch((reject) => {
    //        handleError(reject, commit)
    //    });
    // },
    // Создать трудовую функцию
    async CREATE_WORK_FUNCTION({ commit, rootState }, params) {
        return await httpWithLoader.post(`/${rootState.ork.curOrkId}/work-functions`, params, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('ADD_WORK_FUNCTION', response.data);

            return response.data;
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Создать трудовую функцию для ПС
    async CREATE_WORK_FUNCTION_FOR_STANDARD({ commit, rootState }, params) {
        return await httpWithLoader.post(`/${rootState.ork.curOrkId}/work-functions/store-for-standard`, params, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
            .then((response) => {
                commit('ADD_WORK_FUNCTION', response.data);

                return response.data;
            })
            .catch((reject) => {
                handleError(reject, commit)
            });
    },


    // Обновить трудовую функцию
    async UPDATE_WORK_FUNCTION_FOR_STANDARD({ commit, rootState }, params) {
        const { workFunctionId, ...opts } = params;

        await httpWithLoader.put(`/${rootState.ork.curOrkId}/labor-functions/${ workFunctionId }`, opts, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
            .then((response) => {
                commit('CHANGE_WORK_FUNCTIONS_BY_STANDARD', response.data)
                // commit('CHANGE_WORK_FUNCTIONS_BY_QUALIFICATION', response.data)
            })
            .catch((reject) => {
                handleError(reject, commit)
            });
    },


    // Обновить трудовую функцию
    async UPDATE_WORK_FUNCTION({ commit, rootState }, params) {
        const { workFunctionId, ...opts } = params;

        await httpWithLoader.put(`/${rootState.ork.curOrkId}/work-functions/${ workFunctionId }`, opts, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('CHANGE_WORK_FUNCTIONS_BY_STANDARD', response.data)
            commit('CHANGE_WORK_FUNCTIONS_BY_QUALIFICATION', response.data)
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Получить общие трудовые функции
    async LOAD_COMMON_WORK_FUNCTIONS({ commit, rootState }, query) {
        await httpWithLoader.get(`/${rootState.ork.curOrkId}/common-work-functions?query=${ query }`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_COMMON_WORK_FUNCTIONS', response.data)
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Получить общие трудовые функции без вызова глобального прелоадера
    async SILENT_LOAD_COMMON_WORK_FUNCTIONS({ commit, rootState }, query) {
        await http.get(`/${rootState.ork.curOrkId}/common-work-functions?query=${ query }`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_COMMON_WORK_FUNCTIONS', response.data)
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Получить общую трудовую функцию по id
    async LOAD_COMMON_WORK_FUNCTION({ commit, rootState }, commonWorkFunctionsId) {
        return await httpWithLoader.get(`/${rootState.ork.curOrkId}/common-work-functions/${ commonWorkFunctionsId }`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            return response.data;
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Создать общую трудовую функцию
    async CREATE_COMMON_WORK_FUNCTION({ commit, rootState }, params) {
        return await httpWithLoader.post(`/${rootState.ork.curOrkId}/common-work-functions`, params, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('ADD_COMMON_WORK_FUNCTION_BY_STANDARD', response.data)
            return response.data
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Обновление общую трудовую функцию
    async UPDATE_COMMON_WORK_FUNCTION({ commit, rootState }, params) {
        await httpWithLoader.put(`/${rootState.ork.curOrkId}/common-work-functions/${ params.commonWorkFunctionsId }`, params, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then()
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Удаление общую трудовую функцию
    async DELETE_COMMON_WORK_FUNCTION({ commit, rootState }, commonWorkFunctionsId) {
        await httpWithLoader.delete(`/${rootState.ork.curOrkId}/common-work-functions/${ commonWorkFunctionsId }`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            console.log('response.data: ', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Обновить трудовые функции входящие в общую
    async UPDATE_WORK_FUNCTION_IN_COMMON_WORK_FUNCTION({ commit, rootState }, params) {
        await httpWithLoader.put(`/${rootState.ork.curOrkId}/common-work-functions/${ params.commonWorkFunctionsId }/work-functions`, params.ids, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            console.log('response.data: ', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Удалить трудовые функции входящие в общую
    async DELETE_WORK_FUNCTION_IN_COMMON_WORK_FUNCTION({ commit, rootState }, params) {
        await httpWithLoader.delete(`/${rootState.ork.curOrkId}/common-work-functions/${ params.commonWorkFunctionsId }/work-functions`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            },
            data: params.ids
        })
        .then()
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Получить взаимосвязи
    async LOAD_INTERRELATIONS_BY_QUALIFICATION({ commit, rootState }, params) {
        let qualificationId, parentId;

        if (Array.isArray(params)) {
            qualificationId = params[0];
            parentId = params[1];
        } else {
            qualificationId = parentId = params;
        }

        await httpWithLoader.get(`/${rootState.ork.curOrkId}/qualifications/${ qualificationId }/${ parentId }/trainings`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            let result = response.data.filter(el => el.parent == null || el.parent.id === parentId);

            if (qualificationId === parentId) {
                let intPaths = [];

                let recursiveForTreeElement = function (element, ids) {
                    //используем строку, т.к. если использовать массив, он запоминает в нем весь обход,
                    //а строка именно с учетом рекурсии
                    ids += element.qualification_to.id + ',';

                    //отрезаем лишнюю запятую в конце, разбиваем на массив и переводим строки в числа
                    let pathArray = ids.substring(0, ids.length - 1).split(',').map((x) => parseInt(x));
                    element.path = pathArray;

                    let exIndex = intPaths.findIndex(el => el.id === element.qualification_to.id);

                    if (exIndex >= 0) {
                        //делаем через concat, потому что на диаграмме элемент может быть в нескольких местах
                        //оставляем уникальные
                        intPaths[exIndex].path = [... new Set(intPaths[exIndex].path.concat(pathArray))];
                    } else {
                        intPaths.push({id: element.qualification_to.id, path: pathArray});
                    }

                    for (let arElement of element.qualification_to.trainings) {
                        recursiveForTreeElement(arElement, ids);
                    }
                };

                for (const element of result) {
                    recursiveForTreeElement(element, '');
                }

                commit('SET_INTERRELATIONS_PATHS', intPaths);
            }

            commit('SET_INTERRELATIONS_BY_QUALIFICATION', result);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Получить взаимосвязи не включая глобальный прелоадер
    async SILENT_LOAD_INTERRELATIONS_BY_QUALIFICATION({ commit, rootState }, data) {
        let id = Number.isInteger(data) ? data : data.id;
        let url = Number.isInteger(data) ? `/${rootState.ork.curOrkId}` : ``;
        await http.get(url + `/qualifications/${ id }/trainings`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_INTERRELATIONS_BY_QUALIFICATION', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Сохранить взаимосвязи
    async SAVE_INTERRELATIONS_BY_QUALIFICATION({ commit, rootState }, { qualificationFromId, params }) {
        return await httpWithLoader.post(`/${rootState.ork.curOrkId}/qualifications/${ qualificationFromId }/trainings`, params, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            return response.status
        })
        .catch((reject) => {
            handleError(reject, commit)

            return reject.response.status
        });
    },

    // Удалить взаимосвязи
    async DELETE_INTERRELATIONS_BY_QUALIFICATION({ commit, rootState }, { qualificationId, ids }) {
        await httpWithLoader.delete(`/${rootState.ork.curOrkId}/qualifications/${ qualificationId }/trainings`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            },
            data: ids
        })
        .then((response) => {
            commit('SET_INTERRELATIONS_BY_QUALIFICATION', response.data.filter(el => !ids.includes(el.id)));
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },


    async LOAD_ALL_PROGRAMS({commit, rootState}) {
        await httpWithLoader.get('/education-programs/from-nsi', {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
            .then((response) => {
                commit('SET_EXTERNAL_PROGRAMS', response.data);
            })
            .catch((reject) => {
                handleError(reject, commit);
            });
    },

    // Получить взаимосвязи
    async LOAD_TRAININGS({ commit, rootState }, trainingId) {
        await httpWithLoader.get(`/${rootState.ork.curOrkId}/trainings/${ trainingId }`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_TRAININGS', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Обновить ОП, привязанные к Training
    async UPDATE_TRAININGS({ commit, rootState }, { trainingId, ids }) {
        await httpWithLoader.put(`/${rootState.ork.curOrkId}/trainings/${ trainingId }/programs`, ids, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    async ATTACH_PROGRAMS_TO_TRAINING({commit, rootState}, {trainingId, ids}) {
        await httpWithLoader.put(`/${rootState.ork.curOrkId}/trainings/${trainingId}/attach-programs`, ids, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
            .then((response) => {

            })
            .catch((reject) => {
                handleError(reject, commit);
            });
    },

    async LOAD_PROGRAMS_BY_TRAINING({commit, rootState}, trainingId) {
        await httpWithLoader.get(`/${rootState.ork.curOrkId}/trainings/${trainingId}/programs`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
            .then((response) => {
               commit('SET_PROGRAMS_FOR_TRAINING', response.data);
            });
    },

    // Получить трудовые функции
    async LOAD_WORK_FUNCTIONS({ commit, rootState }) {
        await httpWithLoader.get(`/${rootState.ork.curOrkId}/work-functions`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_WORK_FUNCTIONS', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Получить трудовые функции по id стандарта
    async LOAD_WORK_FUNCTIONS_BY_QUALIFICATION({ commit, rootState }, qualificationId) {
        await httpWithLoader.get(`/${rootState.ork.curOrkId}/qualifications/${ qualificationId }/work-functions`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_WORK_FUNCTIONS_BY_QUALIFICATION', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    async LOAD_WORK_FUNCTIONS_BY_QUALIFICATION_NO_ORK({ commit, rootState }, qualificationId) {
        await httpWithLoader.get(`/qualifications/${ qualificationId }/work-functions`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
            .then((response) => {
                commit('SET_WORK_FUNCTIONS_BY_QUALIFICATION', response.data);
            })
            .catch((reject) => {
                handleError(reject, commit)
            });
    },

    // Получить трудовые функции по id стандарта не включая глобальный прелоадер
    async SILENT_LOAD_WORK_FUNCTIONS_BY_QUALIFICATION({ commit, rootState }, data) {
        let id = Number.isInteger(data) ? data : data.id;
        let url = Number.isInteger(data) ? `/${rootState.ork.curOrkId}` :  `` ;
        await http.get(url + `/qualifications/${ id }/work-functions`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_WORK_FUNCTIONS_BY_QUALIFICATION', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Получить трудовые функции по id стандарта
    async LOAD_WORK_FUNCTIONS_BY_STANDARD({ commit, rootState }, standardId) {
        await httpWithLoader.get(`/${rootState.ork.curOrkId}/standards/${ standardId }/work-functions`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_WORK_FUNCTIONS_BY_STANDARD', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Получить трудовые функции по id стандарта не включая глобальный прелоадер
    async SILENT_LOAD_WORK_FUNCTIONS_BY_STANDARD({ commit, rootState }, standardId) {
        await http.get(`/${rootState.ork.curOrkId}/standards/${ standardId }/work-functions`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_WORK_FUNCTIONS_BY_STANDARD', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Добавит трудовую функцию по id стандарта
    async ADD_WORK_FUNCTIONS_BY_STANDARD({ commit, rootState }, params) {
        await httpWithLoader.put(`/${rootState.ork.curOrkId}/standards/${ params.standardId }/work-functions`, params, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_WORK_FUNCTIONS_BY_STANDARD', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Удалить общую трудовую функцию по id стандарта
    async DELETE_WORK_FUNCTIONS_BY_STANDARD({ commit, rootState }, params) {
        await httpWithLoader.delete(`/${rootState.ork.curOrkId}/standards/${ params.standardId }/work-functions`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            },
            data: params.id
        })
        .then((response) => {
            commit('SET_WORK_FUNCTIONS_BY_STANDARD', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Удалить общую трудовую функцию по id стандарта
    async DELETE_WORK_FUNCTIONS_BY_QUALIFICATION({ commit, rootState }, params) {
        await httpWithLoader.delete(`/${rootState.ork.curOrkId}/qualifications/${ params.qualificationId }/work-functions`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            },
            data: params.ids
        })
        .then((response) => {
            commit('SET_WORK_FUNCTIONS_BY_QUALIFICATION', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    async LOAD_DICTIONARY_WORK_FUNCTION_ITEMS({ commit, rootState }, id) {
        await httpWithLoader.get(`/${rootState.ork.curOrkId}/work-functions/${ id }/items`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
            .then((response) => {
                commit('SET_WORK_FUNCTION_ITEMS', response.data);
            })
            .catch((reject) => {
                handleError(reject, commit)
            });
    },



    // Получить итемы трудовых функций
    async LOAD_WORK_FUNCTION_ITEMS({ commit, rootState }, id) {
        await httpWithLoader.get(`/${rootState.ork.curOrkId}/labor-function/${ id }/items`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_WORK_FUNCTION_ITEMS', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Получить знания
    async LOAD_WORK_KNOWLEDGE({ commit, rootState }, { page = 1, pageSize = 30 }) {
        await httpWithLoader.get(`/${rootState.ork.curOrkId}/work-knowledge?page=${ page }&per_page=${ pageSize }`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_WORK_KNOWLEDGE', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Получить умения
    async LOAD_WORK_SKILLS({ commit, rootState }, { page = 1, pageSize = 30 }) {
        await httpWithLoader.get(`/${rootState.ork.curOrkId}/work-skills?page=${ page }&per_page=${ pageSize }`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_WORK_SKILLS', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Создать трудовое действие
    async CREATE_WORK_ACTION({ state, commit, rootState }, params) {
        return await httpWithLoader.post(`/${rootState.ork.curOrkId}/work-actions`, params, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_WORK_ACTIONS', [...state.workActions, response.data]);

            return response.data;
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Обновить трудовое действие
    async UPDATE_WORK_ACTION({ state, commit, rootState }, params) {
        return await httpWithLoader.put(`/${rootState.ork.curOrkId}/work-actions/${ params.workActionId }`, params, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            return response.data;
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Удалить трудовое действие
    async DELETE_WORK_ACTION({ state, commit, rootState }, id) {
        return await httpWithLoader.delete(`/${rootState.ork.curOrkId}/work-actions/${id}`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then()
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Создать трудовое знание
    async CREATE_WORK_KNOWLEDGE({ state, commit, rootState }, params) {
        return await httpWithLoader.post(`/${rootState.ork.curOrkId}/work-knowledge`, params, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_WORK_KNOWLEDGE', [...state.workKnowledge, response.data]);

            return response.data;
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Обновить трудовое знание
    async UPDATE_WORK_KNOWLEDGE({ state, commit, rootState }, params) {
        return await httpWithLoader.put(`/${rootState.ork.curOrkId}/work-knowledge/${ params.workKnowledgeId }`, params, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            return response.data;
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Удалить трудовое знание
    async DELETE_WORK_KNOWLEDGE({ state, commit, rootState }, id) {
        return await httpWithLoader.delete(`/${rootState.ork.curOrkId}/work-knowledges/${id}`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then()
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Создать трудовое умение
    async CREATE_WORK_SKILL({ state, commit, rootState }, params) {
        return await httpWithLoader.post(`/${rootState.ork.curOrkId}/work-skills`, params, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_WORK_SKILLS', [...state.workSkills, response.data]);

            return response.data;
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Обновить трудовое умение
    async UPDATE_WORK_SKILL({ state, commit, rootState }, params) {
        return await httpWithLoader.put(`/${rootState.ork.curOrkId}/work-skills/${ params.workSkillId }`, params, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            return response.data;
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },


     // Удалить трудовое умение
     async DELETE_WORK_SKILL({ state, commit, rootState }, id) {
        return await httpWithLoader.delete(`/${rootState.ork.curOrkId}/work-skills/${id}`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then()
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Поиск трудовых действий
    async QUERY_WORK_ACTIONS({ commit, rootState }, query) {
        await httpWithLoader.get(`/${rootState.ork.curOrkId}/work-actions?query=${ query }`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_WORK_ACTIONS', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    async GET_WORK_ACTIONS_BY_QUALIFICATION({ commit, rootState }, qualificationId) {
        await httpWithLoader.get(`/${rootState.ork.curOrkId}/qualifications/${qualificationId}/work-actions`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_WORK_ACTIONS', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    async GET_WORK_SKILLS_BY_QUALIFICATION({ commit, rootState }, qualificationId) {
        await httpWithLoader.get(`/${rootState.ork.curOrkId}/qualifications/${qualificationId}/work-skills`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_WORK_SKILLS', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    async GET_WORK_KNOWLEDGE_BY_QUALIFICATION({ commit, rootState }, qualificationId) {
        await httpWithLoader.get(`/${rootState.ork.curOrkId}/qualifications/${qualificationId}/work-knowledge`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_WORK_KNOWLEDGE', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },
    // Поиск трудовых функций (второй уровень)
    async QUERY_WORK_FUNCTIONS({ commit, rootState }, query) {
        await httpWithLoader.get(`/${rootState.ork.curOrkId}/work-functions?query=${ query }`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_WORK_FUNCTIONS', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Поиск трудовых знаний
    async QUERY_WORK_KNOWLEDGE({ commit, rootState }, query) {
        await httpWithLoader.get(`/${rootState.ork.curOrkId}/work-knowledge?query=${ query }`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_WORK_KNOWLEDGE', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Поиск трудовых умений
    async QUERY_WORK_SKILLS({ commit, rootState }, query) {
        await httpWithLoader.get(`/${rootState.ork.curOrkId}/work-skills?query=${ query }`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_WORK_SKILLS', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Обновить итемы трудовых функций для ПС
    async UPDATE_WORK_FUNCTION_ITEMS_FOR_STANDARD({ commit, rootState }, params) {
        const { workFunctionId, ...opts } = params;
        // await httpWithLoader.put(`/${rootState.ork.curOrkId}/work-functions/${ workFunctionId }/items`
        await httpWithLoader.put(`/${rootState.ork.curOrkId}/work-function/${ workFunctionId }/saveItems`, opts, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
            .then((response) => {
                commit('SET_WORK_FUNCTION_ITEMS', response.data);
            })
            .catch((reject) => {
                handleError(reject, commit)
            });
    },




    // Обновить итемы трудовых функций
    async UPDATE_WORK_FUNCTION_ITEMS({ commit, rootState }, params) {
        const { workFunctionId, ...opts } = params;
        // await httpWithLoader.put(`/${rootState.ork.curOrkId}/work-functions/${ workFunctionId }/items`
        await httpWithLoader.put(`/${rootState.ork.curOrkId}/labor-function/${ workFunctionId }/saveItems`, opts, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_WORK_FUNCTION_ITEMS', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Обновить трудовые функции квалификации
    async UPDATE_WORK_FUNCTIONS_BY_QUALIFICATION({ commit, rootState }, { qualificationId, ids }) {
        await httpWithLoader.put(`/${rootState.ork.curOrkId}/qualifications/${ qualificationId }/work-functions`, ids, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_WORK_FUNCTIONS_BY_QUALIFICATION', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Обновить трудовые функции стандарта
    async UPDATE_WORK_FUNCTIONS_BY_STANDART({ commit, rootState }, { standardId, ids }) {
        await httpWithLoader.put(`/${rootState.ork.curOrkId}/standards/${ standardId }/work-functions`, ids, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_WORK_FUNCTIONS_BY_STANDARD', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    /*--------- КОМПЕТЕНЦИИ ---------*/
    // Получить компетенции
    async LOAD_COMPETENCES({ commit, rootState }, params) {
        await httpWithLoader.get(`/${rootState.ork.curOrkId}/competitions`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_COMPETENCES', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Получить хард-скиллы
    // async LOAD_HARD_SKILLS({ commit }, qualificationId) {
    //     await httpWithLoader.get(`/${rootState.ork.curOrkId}/hard-skills?qualification_id=${ qualificationId }`).then((response) => {
    //         commit('SET_HARD_SKILLS', response.data);
    //     }).catch(handleError);
    // },

    // // Получить софт-скиллы
    // async LOAD_SOFT_SKILLS({ commit }, qualificationId) {
    //     await httpWithLoader.get(`/${rootState.ork.curOrkId}/soft-skills?qualification_id=${ qualificationId }`).then((response) => {
    //         commit('SET_SOFT_SKILLS', response.data);
    //     }).catch(handleError);
    // }
    // Обновить трудовые действия
    // async UPDATE_WORK_ACTIONS({ commit }, params) {
    //     await httpWithLoader.put(`/${rootState.ork.curOrkId}/standards/${ params.id }`, {
    //         ...params
    //     }).then((response) => {
    //         commit('UPDATE_WORK_ACTIONS', response.data);
    //     }).catch(handleError);
    // }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
